import { STANDARD_FEC_JOURNAL_CODES, STANDARD_FEC_JOURNAL_LABELS } from '../constants/standardFecJournalCodes'
import { FecJournalMappingStatus } from '../enums/fecJournalMappingStatus'

export const getFecJournalMappingStatus = (journalCode: string, journalLib: string): FecJournalMappingStatus => {
  const normalizedCode = journalCode.trim().toUpperCase()

  if (!STANDARD_FEC_JOURNAL_CODES.has(normalizedCode)) {
    return FecJournalMappingStatus.CustomJournal
  }

  const standardLabels = STANDARD_FEC_JOURNAL_LABELS[normalizedCode]
  const normalizedLabel = journalLib.trim().toLocaleLowerCase()

  if (!standardLabels.some((label) => normalizedLabel === label.toLocaleLowerCase())) {
    return FecJournalMappingStatus.CustomLabel
  }

  return FecJournalMappingStatus.Standard
}
